var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 18,
    height: 18,
    transform: "translate(255 11)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_61",
    "data-name": "Mask Group 61",
    transform: "translate(-255 -11)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(254.4 10.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M18.3,6.079l-8.4-4.8a.6.6,0,0,0-.6,0L.9,6.079a.6.6,0,0,0,.014,1.05l8.4,4.5a.6.6,0,0,0,.567,0l8.4-4.5a.6.6,0,0,0,.014-1.05Zm-8.7,4.34L2.439,6.583,9.6,2.491l7.161,4.092Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M9.889,14.775,18,10.315V8.945l-8.4,4.62L1.2,8.945v1.37l8.111,4.461a.6.6,0,0,0,.578,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M1.2,13.6l8.118,4.329a.6.6,0,0,0,.565,0L18,13.6V12.24L9.6,16.72,1.2,12.24Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.7b893646a7b1348b016842bd1db9d8d8.svg";
export { ForwardRef as ReactComponent };